"use client";
import style from "./InnovationFuture.module.scss";
import { Banner } from "@/components/common/Banner/Banner";
import { TitleAnimation } from "@/components/common/TitleAnimation/TitleAnimation";

const InnovationFuture = ({ messages }: any) => {
  return (
    <section className={style.sectionContainer}>
      <div className="container">
        <TitleAnimation
          messages={{
            first_word: messages.first_words,
            second_word: messages.second_words,
          }}
        />
        <p className={style.description}>{messages.description}</p>
      </div>
      <Banner words={messages.words_banner} />
    </section>
  );
};

export default InnovationFuture;
